var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95BF47",
    d: "M388.3 104.1c-.3-2.3-2.4-3.6-4.1-3.7-1.7-.1-37.2-2.8-37.2-2.8s-24.7-24.5-27.4-27.2c-2.7-2.7-8-1.9-10-1.3-.1 0-5.2 1.6-13.7 4.2-8.4-24.1-23.1-46.2-49-46.2-.7 0-1.5 0-2.2.1-7.4-9.7-16.5-13.9-24.4-13.9-60.6 0-89.5 75.8-98.6 114.3-23.5 7.3-40.2 12.5-42.4 13.2-13.1 4.1-13.5 4.5-15.2 16.9C16.3 180.7 0 480 0 480l301.5 56.5.2-.1 163.4-35.3S388.6 106.4 388.3 104.1zM271.4 75.5l-22.1 6.8c0-1.6.1-3.1.1-4.8 0-14.4-2-26-5.2-35.2 12.9 1.6 21.5 16.3 27.2 33.2zm-45.4-30.1c3.6 9 5.9 21.9 5.9 39.3 0 .9 0 1.7-.1 2.5-14.4 4.5-30 9.3-45.7 14.1 8.8-34 25.3-50.4 39.9-55.9zm-18.3-17.3c2.6 0 5.2.9 7.7 2.6-19.2 9-39.8 31.8-48.5 77.3l-36.1 11.2c10.2-34.8 35.3-91.1 76.9-91.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E8E3E",
    d: "M384.2 100.4c-1.7-.1-37.2-2.8-37.2-2.8s-24.7-24.5-27.4-27.2c-1-1-2.4-1.5-3.8-1.7l-22.8 466.8 163.4-35.3S388.6 106.4 388.3 104.1c-.3-2.3-2.4-3.6-4.1-3.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M273.5 168.3l-20.1 59.8s-17.6-9.4-39.2-9.4c-31.7 0-33.3 19.9-33.3 24.9 0 27.3 71.2 37.8 71.2 101.8 0 50.3-31.9 82.7-75 82.7-51.6 0-77.9-32.1-77.9-32.1l13.8-45.7s27.1 23.3 50 23.3c14.9 0 21-11.8 21-20.4 0-35.7-58.4-37.3-58.4-95.8 0-49.3 35.4-97 106.8-97 27.5 0 41.1 7.9 41.1 7.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShopify);
export default __webpack_public_path__ + "static/media/logo-shopify.03e444ad31cb4bff76209071c2e91b6c.svg";
export { ForwardRef as ReactComponent };